export default __webpack_public_path__ + "static/media/CircuitBoardGraphicFilledarkened.881b4023.png";